import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import AddFaqIndex from "../../../../components/SidetabPages/Configuration/Faqs/AddEditForm";

const AddFaq = () => {
  return (
    <>
      <AnnouncementBar />
      <AddFaqIndex />
    </>
  );
};
export default AddFaq;
